import { FetchCacheItemSources } from '../../../../types';
import {
  FetchCacheLastDefaultCurrencyRateCacheKey,
  FetchCacheLastDefaultCurrencyRateGqlQuery
} from '../../currencyRatesTypes';
import { FetchCacheLastDefaultCurrencyRateQueryResponse } from '../../queries/fetchCacheLastDefaultCurrencyRate.query';

import { FETCH_CACHE_LAST_DEFAULT_CURRENCY_RATE_QUERY } from '../../queries/fetchCacheLastDefaultCurrencyRate.query';

import { useCacheShowQuery } from '../../../common/reactQuery/hooks/useCacheShowQuery';

import { CurrencyRateCache } from '../../CurrencyRateCache';

interface CacheLastDefaultCurrencyRateResponse<ItemType> {
  lastDefaultCurrencyRate: ItemType | null;
}

interface CacheLastDefaultCurrencyRateOptions {
  action?: string;
  cacheKey?: FetchCacheLastDefaultCurrencyRateCacheKey;
  options?: {
    cacheTime?: number;
    enabled?: boolean;
    enabledPlaceholder?: boolean;
    keepPreviousData?: boolean;
    staleTime?: number;
  };
  query?: FetchCacheLastDefaultCurrencyRateGqlQuery;
  source?: FetchCacheItemSources;
}

const itemKey = 'lastDefaultCurrencyRate';

function useCacheLastDefaultCurrencyRate<
  ItemType = FetchCacheLastDefaultCurrencyRateQueryResponse
>({
  action,
  cacheKey = CurrencyRateCache.lastDefaultCacheKey(),
  options = {},
  query = FETCH_CACHE_LAST_DEFAULT_CURRENCY_RATE_QUERY,
  source = FetchCacheItemSources.DB
}: CacheLastDefaultCurrencyRateOptions = {}) {
  const {
    item,
    itemError,
    itemErrorData,
    itemFetched,
    itemFetching,
    itemLoading,
    itemIsPlaceholderData,
    refetchItem,
    updateCacheShowQueryItemCache
  } = useCacheShowQuery<
    CacheLastDefaultCurrencyRateResponse<ItemType>,
    ItemType
  >({
    action,
    cacheKey,
    cacheQuery: query,
    itemKey,
    options,
    query,
    source,
    uuid: itemKey,
    useCacheApiOnly: true
  });

  return {
    lastDefaultCurrencyRate: item,
    lastDefaultCurrencyRateErrorData: itemErrorData,
    lastDefaultCurrencyRateError: itemError,
    lastDefaultCurrencyRateFetched: itemFetched,
    lastDefaultCurrencyRateFetching: itemFetching,
    lastDefaultCurrencyRateLoading: itemLoading,
    lastDefaultCurrencyRateIsPlaceholderData: itemIsPlaceholderData,
    refetchLastDefaultCurrencyRate: refetchItem,
    updateLastDefaultCurrencyRateCache: updateCacheShowQueryItemCache
  };
}

export default useCacheLastDefaultCurrencyRate;
